<template>
    <div class="footer">
        <div class="our">
            <div class="o_title">我们公司</div>
            <div class="o_intro mt_12 ta_center">德国曼稣勒（中国）权利中心</div>
            <div class="o_intro mt_12 ta_center">曼稣勒环境科技（上海）有限公司</div>
            <div class="o_intro mt_8 ta_center">地址：中国（上海）自由贸易试验区富特西一路139号1号楼第一层101室</div>
            <div class="o_intro mt_8 ta_center">联系电话：400-047-5178</div>
            <div class="o_intro mt_8 ta_center">邮政编码：200131</div>
        </div>
        <div class="our mt_48">
            <div class="o_title">备案信息</div>
            <div class="o_intro mt_12"><a style="color: #fff;" href="https://beian.miit.gov.cn/" target="_blank">渝ICP备09061955号-4</a></div>
        </div>
        <div class="code_box mt_48 row_center">
            <div class="guanfang mr_32">
                <img src="../assets/images/qrcode1.png" alt="">
                <div class="content">曼稣勒官方公众号</div>
            </div>
            <div class="guanfang">
                <img src="../assets/images/qrcode2.png" alt="">
                <div class="content">曼稣勒电商小程序</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "mslFooter"
    }
</script>

<style scoped lang="scss">
    /* 底部 */
    .footer {
        padding: 48px;
        box-sizing: border-box;
        background-color: #262626;
        .o_title {
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: bold;
            line-height: 24px;
            color: #FFFFFF;
        }
        .o_intro {
            font-size: 12px;
            font-family: PingFang SC;
            font-weight: 400;
            line-height: 17px;
            color: #FFFFFF;
            opacity: 0.6;
        }
        .mt_12 {
            margin-top: 12px;
        }
        .mt_8 {
            margin-top: 8px;
        }
        .mt_48 {
            margin-top: 48px;
        }
        .code_box {
            .guanfang {
                img {
                    width: 80px;
                    height: 80px;
                }
                .content {
                    font-size: 12px;
                    font-family: PingFang SC;
                    font-weight: 400;
                    line-height: 17px;
                    color: #FFFFFF;
                    opacity: 0.6;
                    margin-top: 8px;
                }
            }
            .mr_32 {
                margin-right: 32px;
            }
        }
    }
</style>
